export const FILLED = 'FILLED';
export const DARK_FILLED = 'DARK_FILLED';
export const UNFILLED = 'UNFILLED';
export const HOLLOW = 'HOLLOW';
export const BRIGHT_HOLLOW = 'BRIGHT_HOLLOW';
export const GRAY_FILLED = 'GRAY_FILLED';
